// extracted by mini-css-extract-plugin
module.exports = {"preloader":"Preloader_preloader__2I1p5","ripple":"Preloader_ripple__37Z_g"};